import { focusDeepWithin } from "@otto-ec/otto-components-utils/utils/focus/focusDeepWithin";
import type { CustomElement } from "./utils";
import { completeElementInit, registerElementInit } from "./performance";
import { addInstance } from "./telemetry";
import { cleanUpFalsyBooleanAttributes } from "./cleanup";
import type { CustomElementExtendOptions } from "./index.ts";

/**
 *
 *
 *
 *
 *
 *
 */
export const shouldAttachShadow = (
  instance: HTMLElement,
  { useShadow = true }: { useShadow?: boolean } = {},
): boolean => !instance.shadowRoot && useShadow;

/**
 *
 *
 *
 *
 *
 *
 */
export const canAttachShadowImmediately = ({
  visibilityInit,
  asyncInit,
}: CustomElementExtendOptions): boolean => !visibilityInit && !asyncInit;

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const extendElementBase = (
  Base: CustomElement,
  options: CustomElementExtendOptions,
): CustomElement =>
  class extends Base {
    constructor(...args: unknown[]) {
      super(...args);

      /*                               */
      addInstance(this.tagName);
      /*                                         */
      registerElementInit(this);

      if (shouldAttachShadow(this, options) && canAttachShadowImmediately(options)) {
        this.$$shadowRoot = this.attachShadow({ mode: "open" });
      }
    }

    async connectedCallback(): Promise<void> {
      /*                                        */
      /*                                     */
      if (shouldAttachShadow(this, options)) {
        this.$$shadowRoot = this.attachShadow({ mode: "open" });
      }

      //
      /*                                                   */
      cleanUpFalsyBooleanAttributes(this);

      /*                                                                          */
      const res = await super.connectedCallback();

      /*                                                   */
      completeElementInit(this);

      /*                                                                         */
      return res;
    }

    /*                                      */
    focus(): void {
      /*                            */
      /*                                                                    */
      /*                                                            */
      /*                                                                                     */
      /*                                                                                                                                                      */
      /*                                                                                                    */
      /*                                                                                                                */
      focusDeepWithin(this);
    }
  };
